import React from "react"
import cx from "classnames"
import { PiTrashDuotone } from "react-icons/pi"
import Tip from "./Tip"

/**
 * The standard remove / archive / delete control: a small red round icon whose tip says
 * what clicking it does. Ask first (app.confirm) when it can't be undone or reaches
 * beyond the row.
 *
 * @param title {String} what the action is - "Archive this type", "Remove this booking"...
 * @param icon {Element} the trash can by default; a restore control passes its own with red={false}
 */
const RemoveControl = ({ title, onClick, icon, red = true, disabled, className, removeStyle }) => (
    <Tip title={title}>
        <div
            style={removeStyle}
            className={cx("dna-under-con sm", { red, "dna-disable": disabled }, className)}
            onClick={disabled ? undefined : onClick}
        >
            {icon || <PiTrashDuotone />}
        </div>
    </Tip>
)

export default RemoveControl
